import { TrendingUp, ExternalLink } from 'lucide-react';
import { BROKER_URL, BROKER_NAME, BROKER_POINTS } from '@/lib/broker';

// Partner-broker referral card, shown at trade-intent moments (chart page,
// gold column). Clearly labelled 合作推廣 with a leverage-risk note.
export default function BrokerCard({ compact = false }: { compact?: boolean }) {
  if (compact) {
    return (
      <a
        href={BROKER_URL}
        target="_blank"
        rel="noreferrer sponsored"
        className="flex items-center justify-between rounded-2xl border border-zinc-200 bg-white px-4 py-3 dark:border-zinc-800 dark:bg-zinc-900"
      >
        <span className="flex items-center gap-2.5 text-sm">
          <span className="flex h-8 w-8 items-center justify-center rounded-xl bg-gradient-to-br from-emerald-500 to-teal-500 text-white">
            <TrendingUp size={16} />
          </span>
          <span>
            <span className="font-medium">優質券商 {BROKER_NAME}</span>
            <span className="block text-[11px] text-zinc-400">合作推廣 · 交易槓桿商品具高風險</span>
          </span>
        </span>
        <ExternalLink size={15} className="shrink-0 text-zinc-400" />
      </a>
    );
  }

  return (
    <section className="mt-5 overflow-hidden rounded-2xl border border-emerald-200/60 bg-gradient-to-br from-emerald-50 to-teal-50/60 p-4 dark:border-emerald-900/40 dark:from-emerald-950/30 dark:to-teal-950/20">
      <div className="mb-1.5 flex items-center gap-2">
        <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-gradient-to-br from-emerald-500 to-teal-500 text-white shadow-md shadow-emerald-500/25">
          <TrendingUp size={18} />
        </span>
        <div>
          <p className="text-sm font-bold leading-tight">
            想交易?優質券商 {BROKER_NAME}
          </p>
          <p className="text-[11px] text-zinc-400">合作推廣</p>
        </div>
      </div>
      <ul className="mb-3 flex flex-wrap gap-x-3 gap-y-1 text-xs text-zinc-600 dark:text-zinc-300">
        {BROKER_POINTS.map((p) => (
          <li key={p} className="flex items-center gap-1">
            <span className="h-1 w-1 rounded-full bg-emerald-500" />
            {p}
          </li>
        ))}
      </ul>
      <a
        href={BROKER_URL}
        target="_blank"
        rel="noreferrer sponsored"
        className="flex w-full items-center justify-center gap-1.5 rounded-xl bg-gradient-to-r from-emerald-500 to-teal-500 py-2.5 text-sm font-semibold text-white shadow-md shadow-emerald-500/25 active:scale-[0.99]"
      >
        前往開戶 <ExternalLink size={14} />
      </a>
      <p className="mt-2 text-center text-[10px] leading-relaxed text-zinc-400">
        差價合約(CFD)為槓桿商品,具高風險,可能損失全部本金;開戶前請自行評估。
      </p>
    </section>
  );
}
